// extracted by mini-css-extract-plugin
export default {"ticketCommentBtn":"ticket_ticketCommentBtn__vBN45","ticketDescription":"ticket_ticketDescription__xB6Lh","ticketBtnSave":"ticket_ticketBtnSave__7NFXi"};